export { MarketingShortTitle } from './marketing-short-title'
